/*
 * Title: Successfull/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Successfully sign up popup.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import { Fragment, useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Lottie from 'react-lottie'
import successGif from "@assets/lotties/success.json";
import { useSelector } from 'react-redux';
import check from "@assets/check.png";
import ProgramBox from "@components/ProgramBox";

const ActionComplete = forwardRef((props, ref) => {
    const creator = useSelector((state: any) => state?.creator);
    const [winner, setWinner] = useState(true);
    const [isShow, setIsShow] = useState(false);
    const [tabActive, setTabActive] = useState(true);
    const [data, setData]: any = useState([]);

    useEffect(() => {
        const handleVisibilityChange = () => {
          setTabActive(document.visibilityState === 'visible');
        };
    
        document.addEventListener('visibilitychange', handleVisibilityChange);
    
        return () => {
          document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
      }, []);

    useImperativeHandle(ref, () => ({
        open(data) {
            setData(data)
            if(document.visibilityState !== 'visible'){
                setTabActive(false);
              } else {
                setTabActive(true);
              }
        },
        close() {
            setIsShow(false);
        },
      }));

      useEffect(() => {
        if(tabActive &&  data.length>0){
            setIsShow(true);
          const timer = setTimeout(() => {
            setIsShow(false);
            setData([]);
            if(document.body.style.overflow === 'hidden'){
                document.body.style.removeProperty('overflow');
            }
            if(document.documentElement.style.overflow === 'hidden'){
                document.documentElement.style.removeProperty('overflow');
            }
        }, 2500);
          return () => clearTimeout(timer);
        }
      }, [tabActive,data.length]);

      const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: successGif,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
        };
    return (
        <Transition.Root show={isShow} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={() => true}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0">
                    <div className="fixed inset-0 bg-[#000]/80 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex items-center justify-center min-h-full p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95">
                            <Dialog.Panel className="relative w-screen h-full overflow-hidden pointer-events-auto">
                                
                                {
                                    winner ? <div className="flex flex-col  items-center justify-center text-center">
                                        <Lottie options={defaultOptions} height={242} width={242} />
                                        <div className="lg:w-[500px] sm:w-[420px] md:w-[420px] w-[330px]">
                                            <h4 className="font-medium text-white lg:text-[36px] md:text-[36px] text-[24px] text-center">
                                            <ProgramBox box="ACTION_COMPLETE_HEADING" />
                                            </h4>
                                            <p className="text-[18px] text-center mb-[40px] leading-[21.6px] text-white opacity-70 font-normal tracking-[1.5px] mt-[10px]">
                                            <ProgramBox box="ACTION_COMPLETE_DESCRIPTION" />
                                            </p>
                                        </div>
                                    </div> :
                                        <div className="flex flex-col items-center justify-center text-center">
                                             <Lottie options={defaultOptions} height={242} width={242} />
                                            <h4 className="font-medium text-white lg:text-[36px] md:text-[36px] text-[24px] text-center">
                                                Nice job!
                                            </h4>
                                            <p className="text-[18px] mb-[40px] leading-[21.6px] text-white opacity-70 font-normal tracking-[1.5px] mt-[10px]">
                                                You completed a new action
                                            </p>
                                            <div className="relative lg:w-[420px] sm:w-[420px] md:w-[420px] w-[330px]">
                                                <div className="bg-tile w-full p-[20px] transition-all duration-700 ease-in-out  rounded-[10px] relative cursor-pointer overflow-hidden">
                                                    <div className="flex justify-between items-center">
                                                        <h6 className="font-[550] text-[16px] tile-inlay-primary">Check in at the Encore NYC meetup</h6>
                                                        <div className="bg-green rounded-full p-[4px] h-5 w-5 flex items-center justify-center z-10 overflow-hidden">
                                                            <img
                                                                src={check}
                                                                alt="Check"
                                                            />
                                                        </div>
                                                    </div>
                                                    <p className="font-normal text-left text-[15px] tile-inlay-primary opacity-80">
                                                        Tap to scan the QR code at the event.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                }
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
});
export default ActionComplete;
